import React, { Children } from 'react';
import {PropTypes} from 'prop-types';
import {PropTypesEx} from '../../shared/proptypes.extensions';
import {ModalBase} from '../../shared/messageBoxComponent';
import {Checkbox} from '../../shared/checkbox';
import {ItemDescriptionComponent} from '../../shared/itemDescriptionComponent';
import {ItemPopupDescriptionComponent} from '../../shared/itemPopupDescriptionComponent';
import {AssignProperties, PreventDOMLock} from '../../shared/utils';
import {LockSymbolComponent} from '../../shared/lockSymbolComponent';
import {ToString, parseNumber} from '../../shared/utils';

import {SERVER_TYPE} from '../../app.defs';

import './joboptionsdlg.scss';

const EMPTY_JOB_OPTION = -1;

const PG_JOB_OPTIONS = {
    PG_DataOnly: 601,
    PG_SchemaOnly: 602,
    PG_LockWaitTimeout: 603,
    PG_Clean: 604,
    PG_IfExists: 605,
    PG_Create: 606,
    PG_Oids: 607,
    PG_NoOwner: 608,
    PG_NoPrivileges: 609,
    PG_DumpFileFormat: 610,
    PG_CommandLine: 650
}

const MY_JOB_OPTIONS = {
    My_SingleTransaction: 401,
    My_LockTables: 402,
    My_PasswordInEnv: 403,
    My_Compatibility: 404,
    My_ColumnStatistics: 405,
    My_Comments: 406,
    My_HeaderComments: 407,

    My_SqlStructure: 420,
    My_AddDropTable: 421,
    My_QuoteNames: 422,
    My_AddCreateProcedure: 423,
    My_AddIfNotExists: 424,
    My_IncludeEvents: 425,
    My_AddCreateDatabase: 426,

    My_SqlData: 440,
    My_CompleteInsert: 441,
    My_ExtendedInsert: 442,
    My_MaxAllowedPacket: 443,
    My_InsertIgnore: 444,
    My_HexBlob: 445,
    My_Replace: 446,

    My_CommandLine: 450
}

const MYPHP_JOB_OPTIONS = {
    MyPhp_CharSet: 501,
    MyPhp_SingleTransaction: 502,
    MyPhp_DisableFK: 503,
    MyPhp_ServerCompression: 504,
    MyPhp_Compatibility: 505,
    MyPhp_Comments: 506,
    MyPhp_HeaderComments: 507,

    MyPhp_SqlStructure: 520,
    MyPhp_AddDropTable: 521,
    MyPhp_AddIfNotExists: 522,
    MyPhp_AddAutoIncrement: 523,
    MyPhp_AddCreateProcedure: 524,
    MyPhp_QuoteNames: 525,

    MyPhp_SqlData: 540,
    MyPhp_CompleteInsert: 541,
    MyPhp_ExtendedInsert: 542,
    MyPhp_MaxQuerySize: 543,
    MyPhp_InsertIgnore: 544,
    MyPhp_HexBlob: 545,
    MyPhp_Replace: 546,
}

const REMOTESQL_JOB_OPTIONS = {
    RemoteSql_CreateSnapshot: 701,
    RemoteSql_TargetEngineType: 702,
    RemoteSql_TargetServerVersion: 703,
    RemoteSql_ContinueOnError: 704,
    RemoteSql_IncludeIfNotExists: 705,
    RemoteSql_ScriptDatabaseDefinition: 706,
    RemoteSql_ScriptSchemas: 707,
    RemoteSql_ScriptRolesAndUsers: 708,
    RemoteSql_ScriptAssemblies: 709,
    RemoteSql_ScriptUserDefinedTypes: 710,
    RemoteSql_ScriptUserDefinedAggregates: 711,
    RemoteSql_ScriptUserDefinedFunctionsAndProcedures: 712,
    RemoteSql_ScriptTables: 713,
    RemoteSql_ScriptData: 714,
    RemoteSql_ScriptViews: 715,
    RemoteSql_ScriptIndexes: 716,
    RemoteSql_ScriptTriggers: 717,
    RemoteSql_ScriptXmlSchemaCollections: 718,
    RemoteSql_ScriptCertificates: 719,
    RemoteSql_ScriptFullTextCatalogs: 720,
}

const LOCALSQL_JOB_OPTIONS = {
    LocalSql_MaxTransferSize: 107,
    LocalSql_BlockSize: 108,
    LocalSql_EnableBufferCount: 109,
    LocalSql_BufferCount: 110,
}

const valueOptionsPropTypes = {
    Id: PropTypes.any.isRequired, 
    StrId: PropTypes.string,
    ValueType: PropTypes.oneOf(['string', 'int', 'bool', 'text']),
    Name: PropTypes.string.isRequired,
    Description: PropTypes.string,
    ValuesList: PropTypes.arrayOf(PropTypes.shape({Key: PropTypes.any.isRequired, Value: PropTypes.string.isRequired})),
    MinValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    MaxValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    MaxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    DefaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    ViewModeHiddenValues: PropTypes.arrayOf(PropTypes.any),
    IsAdditional: PropTypes.bool,
    AvailabilityInfo: PropTypes.shape({HasHardRestriction: PropTypes.bool}),
}

export function isOptionHasNonDefaultValue(option) {
    let result = false;

    if (Boolean(option) && Boolean(option.JobOption)) {
        // if (Boolean(option.JobOption.ValuesList) && Array.isArray(option.JobOption.ValuesList)) {
        //     result = option.Value != option.JobOption.DefaultValue; 
        // }
        // else {
        //     switch (option.JobOption.ValueType) {
        //         case 'bool':
        //             result = Boolean(option.Value) != Boolean(option.JobOption.DefaultValue);
        //             break;
        //         case 'string':
        //             result = Boolean(option.Value);
        //             break;
        //         case 'int':
        //             result = option.Value != option.JobOption.DefaultValue;
        //             break;
        //     }
        // }
        switch (option.JobOption.ValueType) {
            case 'bool':
                result = Boolean(option.Value) != Boolean(option.JobOption.DefaultValue);
                break;
            case 'string':
            case 'text':
                result = ToString(option.Value) != ToString(option.JobOption.DefaultValue);
                break;
            case 'int':
                result = option.Value != option.JobOption.DefaultValue;
                break;
        }
    }
    return result;
}

export function isOptionValueVisible(option) {
    let result = true;

    if (Boolean(option) && Boolean(option.JobOption) && Boolean(option.JobOption.ViewModeHiddenValues)) {
        
        switch (option.JobOption.ValueType) {
            case 'bool':
                result = !option.JobOption.ViewModeHiddenValues.some(p => Boolean(p) == Boolean(option.Value));
                break;
            case 'string':
            case 'text':
                result = !option.JobOption.ViewModeHiddenValues.some(p => ToString(p) == ToString(option.Value));
                break;
            case 'int':
                result = !option.JobOption.ViewModeHiddenValues.some(p => p == option.Value);
                break;
        }
    }

    return result;
}

let optionCounter = 0;
export class OptionControl extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {isCollapsed: true};

        this.handleChange = this.handleChange.bind(this);
        this.handleBooleanChange = this.handleBooleanChange.bind(this);
        this.handleStringChange = this.handleStringChange.bind(this);
        this.handleIntChange = this.handleIntChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);

        this._id = optionCounter++;
        this.getId = this.getId.bind(this);
    }

    getId() {
        const self = this;
        if (Boolean(self.props.id)) {
            return self.props.id;
        }

        return `opt${self._id}`;
    }

    handleChange(newValue) {
        const self = this;
        const {value, valueOptions, onChange} = self.props;

        if (value != newValue){
            onChange(valueOptions, newValue);
        }
    }

    handleBooleanChange(event) {
        const newValue = Boolean(event.target.checked);
        this.handleChange(newValue);
    }

    handleStringChange(event) {
        const self = this;
        const {valueOptions} = self.props;
        let newValue = ToString(event.target.value);
        const maxLength = Math.max(0, parseInt(valueOptions.MaxLength));

        if (!isNaN(maxLength)) {
            newValue = newValue.substr(0, maxLength);
        }

        self.handleChange(newValue);
    }

    handleIntChange(event) {
        const self = this;
        const {valueOptions} = self.props;
        let newValue = parseNumber(event.target.value, 0, valueOptions.MinValue, valueOptions.MaxValue);

        self.handleChange(newValue);
    }

    handleSelectChange(event) {
        const self = this;
        const {valueOptions} = self.props;

        switch (valueOptions.ValueType) {
            case 'bool':
                self.handleBooleanChange(event);
                break;
            case 'string':
            case 'text':
                self.handleStringChange(event);
                break;
            case 'int':
                self.handleIntChange(event);
                break;
        }
    }

    render() {
        const self = this;
        const {value, valueOptions, className, disabled, readOnly, newStyle, hideLabel} = self.props;

        let result = null;

        let popupDescriptionClassName = 'skipautofocus mle-1';
        let valueClassName = '';

        if (Boolean(valueOptions.StrId)) {
            popupDescriptionClassName += ` sh-info-${valueOptions.StrId.toLowerCase()}`;
            valueClassName = `sh-opt-${valueOptions.StrId.toLowerCase()}`;
        }

        const id = self.getId();

        if (Boolean(valueOptions.ValuesList) && Array.isArray(valueOptions.ValuesList)) {
            const selectedValue = valueOptions.ValuesList.find(p => p.Key == value);

            if (newStyle) {
                const minWidth = ((valueOptions.Name || '').length * .4 + 3) + 'rem';

                result = 
                    <div id={self.props.id || undefined} className="d-flex align-items-baseline flex-nowrap">
                        <div className="form-group newstyle">
                            <select
                                id={id + '.select'}
                                className={'custom-select ' + valueClassName + ' ' + ToString(className) + (Boolean(selectedValue) ? '' : ' is-invalid')}
                                disabled={disabled || readOnly}
                                value={Boolean(selectedValue) ? selectedValue.Key : ''} 
                                required
                                onChange={self.handleSelectChange} 
                                style={{minWidth: minWidth}}
                            >
                                {!Boolean(selectedValue) && <option key={-1} value="" disabled hidden />}
                                {valueOptions.ValuesList.map(p => <option key={'opt-' + p.Key} value={p.Key}>{p.Value}</option>)}
                            </select>
                            {!Boolean(hideLabel) &&
                                <label htmlFor={id + '.select'}><span className="text-truncate">{valueOptions.Name}</span></label>
                            }
                        </div>
                        <ItemPopupDescriptionComponent text={valueOptions.Description} className={popupDescriptionClassName} />
                    </div>
            }
            else {
                result = 
                    <div id={self.props.id || undefined} className="d-flex align-items-baseline flex-wrap">
                        {!Boolean(hideLabel) &&
                            <label className="m-0 mre-2 option-label" htmlFor={id + '.select'}>{valueOptions.Name}:</label>
                        }
                        <div className="option-value d-flex align-items-baseline flex-nowrap">
                            <select
                                id={id + '.select'}
                                className={'custom-select compact ' + valueClassName + ToString(className) + (Boolean(selectedValue) ? '' : ' is-invalid')}
                                disabled={disabled || readOnly}
                                value={Boolean(selectedValue) ? selectedValue.Key : ''} 
                                required
                                onChange={self.handleSelectChange} 
                            >
                                {!Boolean(selectedValue) && <option key={-1} value="" disabled hidden />}
                                {valueOptions.ValuesList.map(p => <option key={'opt-' + p.Key} value={p.Key}>{p.Value}</option>)}
                            </select>
                            <ItemPopupDescriptionComponent text={valueOptions.Description} className={popupDescriptionClassName} />
                        </div>
                    </div>
            }
        }
        else {
            switch (valueOptions.ValueType) {
                case 'bool':
                    result = 
                        <Checkbox 
                            id={id}
                            className={'d-inline1 ' + ToString(className)}
                            disabled={disabled}
                            checked={Boolean(value)} 
                            readOnly={readOnly}
                            onChange={self.handleBooleanChange} 
                            label={
                                <>
                                    <span className={'text-secondary ' + valueClassName}>{valueOptions.Name}</span>
                                    <ItemPopupDescriptionComponent text={valueOptions.Description} className={popupDescriptionClassName} />
                                </>
                            }
                        />

                    break;
                
                case 'string':
                    const maxStrLength = parseInt(valueOptions.MaxLength) || null;

                    if (newStyle) {
                        result = 
                            <div id={self.props.id || undefined} className="d-flex flex-nowrap align-items-baseline">
                                <div className="form-group newstyle flex-grow-1">
                                    <input 
                                        id={id + '.str'}
                                        className={valueClassName + ' form-control ' + ToString(className)}
                                        type="text"
                                        disabled={disabled}
                                        readOnly={readOnly}
                                        value={ToString(value)} 
                                        maxLength={maxStrLength}
                                        onChange={self.handleStringChange} 
                                    />
                                    {!Boolean(hideLabel) &&
                                        <label htmlFor={id + '.str'}>
                                            <span className="text-truncate mre-1">{valueOptions.Name}</span>
                                            <ItemPopupDescriptionComponent text={valueOptions.Description} className={popupDescriptionClassName} />
                                        </label>
                                    }
                                </div>
                            </div>
                    }
                    else {
                        result = 
                            <div id={self.props.id || undefined}>
                                {!Boolean(hideLabel) &&
                                    <label className="m-0 option-label" htmlFor={id + '.str'}>{valueOptions.Name}:</label>
                                }
                                <div className="option-value d-flex align-items-baseline flex-nowrap">
                                    <input 
                                        id={id + '.str'}
                                        className={valueClassName + ' form-control compact ' + ToString(className)}
                                        type="text"
                                        disabled={disabled}
                                        readOnly={readOnly}
                                        value={ToString(value)} 
                                        maxLength={maxStrLength}
                                        onChange={self.handleStringChange} 
                                    />
                                    <ItemPopupDescriptionComponent text={valueOptions.Description} className={popupDescriptionClassName} />
                                </div>
                            </div>
                    }

                    break;

                case 'text':
                    const maxTxtLength = parseInt(valueOptions.MaxLength) || null;

                    if (newStyle) {
                        result = 
                            <div id={self.props.id || undefined} className="d-flex flex-nowrap align-items-baseline">
                                <div className="form-group newstyle flex-grow-1">
                                    <textarea 
                                        id={id + '.txt'}
                                        className={valueClassName + ' form-control ' + ToString(className)}
                                        disabled={disabled}
                                        readOnly={readOnly}
                                        value={ToString(value)} 
                                        maxLength={maxTxtLength}
                                        rows={3}
                                        onChange={self.handleStringChange} 
                                    />
                                    {!Boolean(hideLabel) &&
                                        <label htmlFor={id + '.txt'}>
                                            <span className="text-truncate mre-1">{valueOptions.Name}</span>
                                            <ItemPopupDescriptionComponent text={valueOptions.Description} className={popupDescriptionClassName} />
                                        </label>
                                    }
                                </div>
                            </div>
                    }
                    else {
                        result = 
                            <div id={self.props.id || undefined}>
                                {!Boolean(hideLabel) &&
                                    <label className="m-0 option-label" htmlFor={id + '.txt'}>{valueOptions.Name}:</label>
                                }
                                <div className="option-value d-flex align-items-baseline flex-nowrap">
                                    <textarea 
                                        id={id + '.txt'}
                                        className={valueClassName + ' form-control compact ' + ToString(className)}
                                        disabled={disabled}
                                        readOnly={readOnly}
                                        value={ToString(value)} 
                                        maxLength={maxTxtLength}
                                        rows={3}
                                        onChange={self.handleStringChange} 
                                    />
                                    <ItemPopupDescriptionComponent text={valueOptions.Description} className={popupDescriptionClassName} />
                                </div>
                            </div>
                    }

                    break;
    
                case 'int':
                    let minValue = parseInt(valueOptions.MinValue);
                    let maxValue = parseInt(valueOptions.MaxValue);

                    let inputDigits = 0;
                    if (!isNaN(minValue)) {
                        inputDigits = Math.max(inputDigits, (minValue + '').length);
                    }
                    else {
                        minValue = undefined;
                    }
                    if (!isNaN(maxValue)) {
                        inputDigits = Math.max(inputDigits, (maxValue + '').length);
                    }
                    else {
                        maxValue = undefined;
                    }
                    inputDigits = Math.max(2, Math.min(6, inputDigits));

                    result = 
                        <div id={self.props.id || undefined} className="d-flex align-items-baseline">
                            {!Boolean(hideLabel) &&
                                <label className="m-0 mre-2 option-label" htmlFor={id + '.int'}>{valueOptions.Name}:</label>
                            }
                            <div className="option-value d-flex align-items-baseline flex-nowrap">
                                <input 
                                    id={id + '.int'}
                                    className={valueClassName + ' form-control compact text-right ' + ToString(className)}
                                    type="number"
                                    style={{width: `${inputDigits}em`}}
                                    min={minValue}
                                    max={maxValue}
                                    disabled={disabled}
                                    readOnly={readOnly}
                                    value={parseInt(value) || 0} 
                                    onChange={self.handleIntChange} 
                                />
                                <ItemPopupDescriptionComponent text={valueOptions.Description} className={popupDescriptionClassName} />
                            </div>
                        </div>

                    break;
            }
        }

        return result;
    }

}
OptionControl.propTypes = {
    value: PropTypes.any,
    valueOptions: PropTypes.shape(valueOptionsPropTypes).isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    hideLabel: PropTypes.bool, 
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    newStyle: PropTypes.bool,
    id: PropTypesEx.elementId,
}
OptionControl.defaultProps = {
    className: '',
    disabled: false,
    readOnly: false,
    newStyle: false,
}

export class JobOptionsDlgComponent extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);
        this.strings = {...this.constructor.defaultProps.strings};
        AssignProperties(this.strings, props.strings);

        this.state = {
            modalResult: null,
            values: []
        }; 

        this.modalRef = React.createRef();
        this.hideDialog = this.hideDialog.bind(this);
        this.handleDialogHide = this.handleDialogHide.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);

        this.handleOptionChanged = this.handleOptionChanged.bind(this);
        this.handleResetToDefaultsClick = this.handleResetToDefaultsClick.bind(this);
        this.getOptionValue = this.getOptionValue.bind(this);
        this.getOptionValueById = this.getOptionValueById.bind(this);
        this.isOptionVisible = this.isOptionVisible.bind(this);

        this.collectKeysFromOptionDatas = this.collectKeysFromOptionDatas.bind(this);
        this.renderOptionsSet = this.renderOptionsSet.bind(this);
        this.renderMySqlOptions = this.renderMySqlOptions.bind(this);
        this.renderMySqlPhpOptions = this.renderMySqlPhpOptions.bind(this);
        this.renderPostgreSqlOptions = this.renderPostgreSqlOptions.bind(this);
        this.renderRemoteSqlOptions = this.renderRemoteSqlOptions.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;
        if (self.props.serverTypeId != prevProps.serverTypeId) {
            self.setState({values: []});
        }
    }

    hideDialog() {
        ModalBase.HideModal(this.modalRef.current);
    }

    handleDialogHide() {
        const self = this;
        self.props.onHide(self.state.modalResult);
    }

    handleCancelClick() {
        const self = this;

        PreventDOMLock(() => {
            if (self._isMounted) {
                self.setState({modalResult: null}, self.hideDialog);
            }
        });
    }

    handleSaveClick() {
        const self = this;

        PreventDOMLock(() => {
            if (self._isMounted) {
                self.setState({modalResult: self.state.values.slice()}, self.hideDialog);
            }
        });
    }

    isOptionVisible(option) {
        const self = this;
        const readOnly = self.props.readOnly;

        let result = 
            Boolean(option) &&
            !Boolean(option.AvailabilityInfo?.HasHardRestriction) && 
            (
                Boolean(option.JobOption.IsAdditional) || 
                (option.Key == MY_JOB_OPTIONS.My_SqlStructure) || 
                (option.Key == MY_JOB_OPTIONS.My_SqlData) ||
                (option.Key == MYPHP_JOB_OPTIONS.MyPhp_SqlStructure) || 
                (option.Key == MYPHP_JOB_OPTIONS.MyPhp_SqlData)
            );

        if (result && readOnly) {
            switch (option.JobOption.ValueType) {
                case 'bool':
                case 'string':
                    result = Boolean(self.getOptionValue(option));
                    break;
            }
        }

        return result;
    }

    getOptionValue(option) {
        const self = this;
        let result = null;

        if (Boolean(option)) {
            // const optionValue = self.state.values.find(p => p.Key == option.Key);
            // result = Boolean(optionValue) ? optionValue.Value : option.Value;

            result = self.state.values
                .find(p => p.Key == option.Key)?.Value ?? option.Value;
        }

        return result;
    }

    getOptionValueById(id) {
        const self = this;

        const result = self.getOptionValue(self.props.options.find(p => p.Key == id));

        return result;
    }

    handleOptionChanged(jobOption, value) {
        const self = this;

        const newValues = self.state.values.filter(p => p.Key != jobOption.Id);
        newValues.push({Key: jobOption.Id, Value: value});

        // PreventDOMLock(() => {
        //     if (self._isMounted) {
        //         self.setState({values: newValues});
        //     }
        // });
        if (self._isMounted) {
            self.setState({values: newValues});
        }
    }

    handleResetToDefaultsClick() {
        const self = this;
        const newValues = self.props.options
            .filter(self.isOptionVisible)
            .map(p => {return {Key: p.Key, Value: p.JobOption.DefaultValue};});

        PreventDOMLock(() => {
            if (self._isMounted) {
                self.setState({values: newValues});
            }
        });
    }

    collectKeysFromOptionDatas(jobOptionDatas, keys) {
        if (Boolean(jobOptionDatas) && Array.isArray(jobOptionDatas)) {
            jobOptionDatas.forEach(item => {
                keys.push(item.Key);

                if (Boolean(item.Child)) {
                    keys.push(item.Child.Key);
                }

                this.collectKeysFromOptionDatas(item.Children, keys);
            });
        };
    }

    renderOptionsSet(jobOptionDatas, isDisabled) {
        const self = this;
        const {options, readOnly, id, newStyle} = self.props;

        return (
            <table className="optionslist">
                <tbody>
                    {jobOptionDatas
                        .map((optionData, i) => {
                            if (optionData.IsHidden) {
                                return null;
                            }

                            if (optionData.Key == EMPTY_JOB_OPTION) {
                                return (
                                    <tr key={'empty-' + i}>
                                        <td/>
                                        <td/>
                                    </tr>
                                )
                            }

                            const jobOption = options.find(p => p.Key == optionData.Key);

                            if (!Boolean(jobOption) || Boolean(jobOption.AvailabilityInfo?.HasHardRestriction) || !self.isOptionVisible(jobOption)) {
                                return null;
                            }

                            const value = self.getOptionValue(jobOption);
                            let className = ToString(optionData.ClassName || '');
                            // if (jobOption.HasWarning) {
                            //     className += ' is-warning';
                            // }

                            const childOption = Boolean(optionData.Child)
                                ? options.find(p => p.Key == optionData.Child.Key)
                                : null;

                            const childValue = Boolean(childOption)
                                ? self.getOptionValue(childOption)
                                : null;

                            const childClassName = Boolean(childOption)
                                ? ToString(optionData.Child.ClassName || '')
                                : null;

                            return (
                                <tr key={'jo-' + i}>
                                    <td width="1" >
                                        <LockSymbolComponent availabilityInfo={jobOption.AvailabilityInfo} className="mre-1" />
                                    </td>
                                    {Boolean(childOption) && 
                                        <td>
                                            <div className="d-flex">
                                                <OptionControl
                                                    id={PropTypesEx.elementId.fnNormalizeId(id + `.opt${jobOption.JobOption.StrId || jobOption.JobOption.Name}`)}
                                                    className={className}
                                                    disabled={isDisabled || Boolean(optionData.Disabled)}
                                                    readOnly={readOnly}
                                                    valueOptions={jobOption.JobOption}
                                                    value={value}
                                                    onChange={self.handleOptionChanged}
                                                    newStyle={newStyle}
                                                />
                                                <OptionControl 
                                                    id={PropTypesEx.elementId.fnNormalizeId(id + `.opt${childOption.JobOption.StrId || childOption.JobOption.Name}`)}
                                                    className={childClassName}
                                                    disabled={isDisabled || Boolean(optionData.Child.Disabled)}
                                                    readOnly={readOnly}
                                                    valueOptions={childOption.JobOption}
                                                    value={childValue}
                                                    onChange={self.handleOptionChanged}
                                                    newStyle={newStyle}
                                                    hideLabel
                                                />
                                            </div>
                                        </td>
                                    }
                                    {!Boolean(childOption) &&
                                        <td>
                                            <OptionControl
                                                id={PropTypesEx.elementId.fnNormalizeId(id + `.opt${jobOption.JobOption.StrId || jobOption.JobOption.Name}`)}
                                                className={className}
                                                disabled={isDisabled || Boolean(optionData.Disabled)}
                                                readOnly={readOnly}
                                                valueOptions={jobOption.JobOption}
                                                value={value}
                                                onChange={self.handleOptionChanged}
                                                newStyle={newStyle}
                                            />
                                            {Boolean(optionData.Children) && Array.isArray(optionData.Children) && optionData.Children.some(p => !p.IsHidden) &&
                                                <div className="children-container">{self.renderOptionsSet(optionData.Children, isDisabled)}</div>
                                            }
                                        </td>
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        )
    }

    renderPostgreSqlOptions(isDisabled) {
        const self = this;
        const strings = self.strings;
        const {options, readOnly} = self.props;

        let optionDatas = [
            {Key: PG_JOB_OPTIONS.PG_DumpFileFormat},
            {Key: PG_JOB_OPTIONS.PG_DataOnly},
            {Key: PG_JOB_OPTIONS.PG_SchemaOnly},
            {Key: PG_JOB_OPTIONS.PG_LockWaitTimeout},

            {Key: EMPTY_JOB_OPTION},

            {Key: PG_JOB_OPTIONS.PG_Clean},
            {Key: PG_JOB_OPTIONS.PG_IfExists},
            {Key: PG_JOB_OPTIONS.PG_Create},

            {Key: EMPTY_JOB_OPTION},

            {Key: PG_JOB_OPTIONS.PG_Oids},
            {Key: PG_JOB_OPTIONS.PG_NoOwner},
            {Key: PG_JOB_OPTIONS.PG_NoPrivileges},

            {Key: EMPTY_JOB_OPTION},

            {Key: PG_JOB_OPTIONS.PG_CommandLine},
        ]

        const allKeys = [];
        self.collectKeysFromOptionDatas(optionDatas, allKeys);

        const otherOptions = options
            .filter(self.isOptionVisible)
            .filter(p => !allKeys.some(key => key == p.Key))
            .map(p => {
                return {Key: p.Key}
            })

        if (otherOptions.length > 0) {
            optionDatas.push({Key: EMPTY_JOB_OPTION});
            optionDatas = optionDatas.concat(otherOptions);
        }

        return(
            <div>
                {!readOnly &&
                    <div className="pb-3">
                        <ItemDescriptionComponent>
                            {strings.MSG_PostgreSqlOptions}
                        </ItemDescriptionComponent>
                    </div>
                }
                <div className="joboptions-container">
                    {self.renderOptionsSet(optionDatas, isDisabled)}
                </div>
            </div>
        )
    }

    renderMySqlOptions(isDisabled) {
        const self = this;
        const {options, readOnly} = self.props;

        const strings = self.strings;
        const structureOptionValue = Boolean(self.getOptionValueById(MY_JOB_OPTIONS.My_SqlStructure));
        const dataOptionValue = Boolean(self.getOptionValueById(MY_JOB_OPTIONS.My_SqlData));

        let optionDatas = [
            {Key: MY_JOB_OPTIONS.My_SingleTransaction},
            {Key: MY_JOB_OPTIONS.My_LockTables},
            {Key: MY_JOB_OPTIONS.My_PasswordInEnv},
            {Key: MY_JOB_OPTIONS.My_Compatibility},
            {Key: MY_JOB_OPTIONS.My_ColumnStatistics},
            {Key: MY_JOB_OPTIONS.My_Comments},
            {Key: MY_JOB_OPTIONS.My_HeaderComments},

            {Key: EMPTY_JOB_OPTION},

            {
                Key: MY_JOB_OPTIONS.My_SqlStructure, 
                ClassName: 'font-weight-bold', 
                Children: [
                    {Key: MY_JOB_OPTIONS.My_AddDropTable, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                    {Key: MY_JOB_OPTIONS.My_QuoteNames, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                    {Key: MY_JOB_OPTIONS.My_AddCreateProcedure, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                    {Key: MY_JOB_OPTIONS.My_AddIfNotExists, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                    {Key: MY_JOB_OPTIONS.My_IncludeEvents, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                    {Key: MY_JOB_OPTIONS.My_AddCreateDatabase, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                ]
            },

            {Key: EMPTY_JOB_OPTION},

            {
                Key: MY_JOB_OPTIONS.My_SqlData, 
                ClassName: 'font-weight-bold', 
                Children: [
                    {Key: MY_JOB_OPTIONS.My_CompleteInsert, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                    {Key: MY_JOB_OPTIONS.My_ExtendedInsert, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                    {Key: MY_JOB_OPTIONS.My_MaxAllowedPacket, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                    {Key: MY_JOB_OPTIONS.My_InsertIgnore, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                    {Key: MY_JOB_OPTIONS.My_HexBlob, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                    {Key: MY_JOB_OPTIONS.My_Replace, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                ]
            },

            {Key: EMPTY_JOB_OPTION},

            {Key: MY_JOB_OPTIONS.My_CommandLine},
        ]

        const allKeys = [];
        self.collectKeysFromOptionDatas(optionDatas, allKeys);

        const otherOptions = options
            .filter(self.isOptionVisible)
            .filter(p => !allKeys.some(key => key == p.Key))
            .map(p => {
                return {Key: p.Key}
            })

        if (otherOptions.length > 0) {
            optionDatas.push({Key: EMPTY_JOB_OPTION});
            optionDatas = optionDatas.concat(otherOptions);
        }

        return(
            <div>
                {!readOnly &&
                    <div className="pb-3 fs-sm text-secondary">
                        <ItemDescriptionComponent>
                            {strings.MSG_MySqlOptions}
                        </ItemDescriptionComponent>
                    </div>
                }
                <div className="joboptions-container">
                    {self.renderOptionsSet(optionDatas, isDisabled)}
                </div>
            </div>
        )
    }

    renderMySqlPhpOptions(isDisabled) {
        const self = this;
        const strings = self.strings;
        const {options, readOnly} = self.props;

        const structureOptionValue = Boolean(self.getOptionValueById(MYPHP_JOB_OPTIONS.MyPhp_SqlStructure));
        const dataOptionValue = Boolean(self.getOptionValueById(MYPHP_JOB_OPTIONS.MyPhp_SqlData));

        let optionDatas = [
            {Key: MYPHP_JOB_OPTIONS.MyPhp_CharSet},
            {Key: MYPHP_JOB_OPTIONS.MyPhp_SingleTransaction},
            {Key: MYPHP_JOB_OPTIONS.MyPhp_DisableFK},
            {Key: MYPHP_JOB_OPTIONS.MyPhp_ServerCompression},
            {Key: MYPHP_JOB_OPTIONS.MyPhp_Compatibility},
            {Key: MYPHP_JOB_OPTIONS.MyPhp_Comments},
            {Key: MYPHP_JOB_OPTIONS.MyPhp_HeaderComments},

            {Key: EMPTY_JOB_OPTION},

            {
                Key: MYPHP_JOB_OPTIONS.MyPhp_SqlStructure, 
                ClassName: 'font-weight-bold', 
                Children: [
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_AddDropTable, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_AddIfNotExists, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_AddAutoIncrement, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_AddCreateProcedure, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_QuoteNames, Disabled: !structureOptionValue, IsHidden: !structureOptionValue && readOnly},
                ]
            },
        
            {Key: EMPTY_JOB_OPTION},

            {
                Key: MYPHP_JOB_OPTIONS.MyPhp_SqlData, 
                ClassName: 'font-weight-bold', 
                Children: [
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_CompleteInsert, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_ExtendedInsert, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_MaxQuerySize, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_InsertIgnore, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_HexBlob, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                    {Key: MYPHP_JOB_OPTIONS.MyPhp_Replace, Disabled: !dataOptionValue, IsHidden: !dataOptionValue && readOnly},
                ]
            },
        ]

        const allKeys = [];
        self.collectKeysFromOptionDatas(optionDatas, allKeys);

        const otherOptions = options
            .filter(self.isOptionVisible)
            .filter(p => !allKeys.some(key => key == p.Key))
            .map(p => {
                return {Key: p.Key}
            })

        if (otherOptions.length > 0) {
            optionDatas.push({Key: EMPTY_JOB_OPTION});
            optionDatas = optionDatas.concat(otherOptions);
        }

        return(
            <div>
                {!readOnly &&
                    <div className="pb-3">
                        <ItemDescriptionComponent>
                            {strings.MSG_PhpMyAdminOptions}
                        </ItemDescriptionComponent>
                    </div>
                }
                <div className="joboptions-container">
                    {self.renderOptionsSet(optionDatas, isDisabled)}
                </div>
            </div>
        )
    }

    renderRemoteSqlOptions(isDisabled) {
        const self = this;
        const strings = self.strings;
        const {options, readOnly} = self.props;

        const ENGINE_TYPE_Standalone = 1;
        const engineTypeOptionValue = parseInt(self.getOptionValueById(REMOTESQL_JOB_OPTIONS.RemoteSql_TargetEngineType));

        let optionDatas = [
            {Key: REMOTESQL_JOB_OPTIONS.RemoteSql_TargetEngineType},
            {Key: REMOTESQL_JOB_OPTIONS.RemoteSql_TargetServerVersion, Disabled: engineTypeOptionValue != ENGINE_TYPE_Standalone, IsHidden: engineTypeOptionValue != ENGINE_TYPE_Standalone},
            {Key: REMOTESQL_JOB_OPTIONS.RemoteSql_ContinueOnError},

            {Key: EMPTY_JOB_OPTION},
        ]

        const allKeys = [];
        self.collectKeysFromOptionDatas(optionDatas, allKeys);

        const otherOptions = options
            .filter(self.isOptionVisible)
            .filter(p => !allKeys.some(key => key == p.Key))
            .map(p => {
                return {Key: p.Key}
            })

        if (otherOptions.length > 0) {
            optionDatas.push({Key: EMPTY_JOB_OPTION});
            optionDatas = optionDatas.concat(otherOptions);
        }

        return(
            <div>
                {!readOnly &&
                    <div className="pb-3">
                        <ItemDescriptionComponent>
                            {strings.MSG_RemoteSqlOptions}
                        </ItemDescriptionComponent>
                    </div>
                }
                <div className="joboptions-container">
                    {self.renderOptionsSet(optionDatas, isDisabled)}
                </div>
            </div>
        )
    }

    renderLocalSqlOptions(isDisabled) {
        const self = this;
        const strings = self.strings;
        const {options, readOnly} = self.props;

        const enableBufferCountOptionValue = Boolean(self.getOptionValueById(LOCALSQL_JOB_OPTIONS.LocalSql_EnableBufferCount));

        let optionDatas = [
            {Key: LOCALSQL_JOB_OPTIONS.LocalSql_MaxTransferSize},
            {Key: LOCALSQL_JOB_OPTIONS.LocalSql_BlockSize},

            {
                Key: LOCALSQL_JOB_OPTIONS.LocalSql_EnableBufferCount,
                Child: {Key: LOCALSQL_JOB_OPTIONS.LocalSql_BufferCount, Disabled: !enableBufferCountOptionValue, IsHidden: !enableBufferCountOptionValue && readOnly, ClassName: 'mle-2'},
                // Children: [
                //     {Key: LOCALSQL_JOB_OPTIONS.LocalSql_BufferCount, Disabled: !enableBufferCountOptionValue, IsHidden: !enableBufferCountOptionValue && readOnly},
                // ]
            }
        ];

        const allKeys = [];
        self.collectKeysFromOptionDatas(optionDatas, allKeys);

        const otherOptions = options
            .filter(self.isOptionVisible)
            .filter(p => !allKeys.some(key => key == p.Key))
            .map(p => {
                return {Key: p.Key}
            })

        if (otherOptions.length > 0) {
            optionDatas.push({Key: EMPTY_JOB_OPTION});
            optionDatas = optionDatas.concat(otherOptions);
        }

        return(
            <div className="joboptions-container">
                {self.renderOptionsSet(optionDatas, isDisabled)}
            </div>
        )        
    }
    
    render() {
        const self = this;

        const {serverTypeId, options, readOnly, id, title} = self.props;
        const strings = self.strings;

        let content = null;
        let isDisabled = false;

        switch (serverTypeId) {
            case SERVER_TYPE.PostgreSql:
                content = self.renderPostgreSqlOptions(isDisabled);
                break;

            case SERVER_TYPE.MySQLServer:
                content = self.renderMySqlOptions(isDisabled);
                break;
            
            case SERVER_TYPE.PhpMyAdminServer:
                content = self.renderMySqlPhpOptions(isDisabled);
                break;
            
            case SERVER_TYPE.RemoteSQLServer:
                content = self.renderRemoteSqlOptions(isDisabled);
                break;
            
            case SERVER_TYPE.LocalSQLServer:
                content = self.renderLocalSqlOptions(isDisabled);
                break;
            
            default:
                content = 
                    <div className="joboptions-container">
                        {self.renderOptionsSet(options.filter(self.isOptionVisible), isDisabled)}
                    </div>;
                break;
        }

        return (
            <ModalBase
                id={id}
                ref={self.modalRef}
                visible
                autoFocus
                className="newstyle"
                allowClose={!isDisabled}
                size="lg"
                title={title || strings.DLG_JobOptions_Title}
                body={
                    <div>
                        {content}
                    </div>
                }
                footer={
                    <div className="w-100 d-flex align-items-center">
                        {!readOnly && 
                            <button type="button" className="likelink fs-sm" onClick={self.handleResetToDefaultsClick}>{strings.BTN_ResetToDefaults}</button>
                        }
                        <div className="justify-content-end1 form-buttons ml-auto">
                            {!readOnly &&
                                <button type="button" className="btn btn-outline-primary btn-sm newstyle" disabled={isDisabled} onClick={self.handleSaveClick}>{strings.BTN_SaveAndClose}</button>
                            }
                            <button type="button" className="btn btn-outline-secondary btn-sm newstyle" disabled={isDisabled} onClick={self.handleCancelClick}>{strings.BTN_Cancel}</button>
                        </div>
                    </div>
                }
                onHide={self.handleDialogHide}
            />
        )
    }
}
JobOptionsDlgComponent.propTypes = {
    strings: PropTypes.object,
    serverTypeId: PropTypes.number.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        Key: PropTypes.any.isRequired, 
        Value: PropTypes.any, 
        JobOption: PropTypes.shape(valueOptionsPropTypes)
    })).isRequired,
    onHide: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    newStyle: PropTypes.bool,
    id: PropTypesEx.elementId.isRequired,
    title: PropTypes.string,
}
JobOptionsDlgComponent.defaultProps = {
    strings: {
        DLG_JobOptions_Title: 'Job options',
        BTN_Cancel: 'Cancel',
        BTN_SaveAndClose: 'Save & Close',
        BTN_ResetToDefaults: 'Reset to defaults',
        MSG_MySqlOptions: 'Here you can set the options for generated SQL backup file. These options are equivalent to the options of mysqldump command.',
        MSG_PhpMyAdminOptions: 'Here you can set the options for generated SQL backup file. These options are equivalent to the options of phpMyAdmin site.',
        MSG_PostgreSqlOptions: 'Here you can set the options for generated SQL backup file. These options are equivalent to the options of pg_dump command.',
        MSG_RemoteSqlOptions: 'Here you can set the options for generated SQL backup file.',
    },
    readOnly: false,
    newStyle: false,
}
